// extracted by mini-css-extract-plugin
export default {"heroImage":"Hero_heroImage__nbWbB"};